import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface User {
  id: number;
  name: string;
  email: string;
}

interface AuthState {
  token: string | null;
  user: User | null;
  setAuth: (token: string, user: User) => void;
  logout: () => void;
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      token: null,
      user: null,
      setAuth: (token, user) => {
        localStorage.setItem('token', token);
        set({ token, user });
      },
      logout: () => {
        clearAuthSession();
      },
    }),
    {
      name: 'sys-auth',
      partialize: (state) => ({ token: state.token, user: state.user }),
    }
  )
);

export function clearAuthSession() {
  localStorage.removeItem('token');
  useAuthStore.setState({ token: null, user: null });
}
